/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function() {
    initCustomizationText();
  });

  /**
   * Inicializa la funcionalidad de personalización de texto para grabados
   */
  function initCustomizationText() {
    /* Save customization_text field for products */
    const required_fields = []

    // handle custom text input
    const customization_text_input = document.getElementById("customization_text");
    if (null !== customization_text_input) {
      if(customization_text_input.getAttribute('required') !== null) {
        required_fields.push('customization_text_hidden');
      }
      
      // Asegurarse de que el formulario tenga el ID del producto
      const productForm = document.querySelector("form.product-form");
      
      if (productForm) {
        const existingIdInput = productForm.querySelector('input[name="id"]');
        
        // Buscamos el selector de variantes y el ID de variante seleccionado actualmente
        const variantSelector = document.querySelector('[name="id"][form]');
        const variantId = variantSelector ? variantSelector.value : null;
        
        if (!existingIdInput) {
          // Si no existe el input, lo creamos
          if (variantId) {
            const idInput = document.createElement("input");
            idInput.setAttribute("type", "hidden");
            idInput.setAttribute("name", "id");
            idInput.setAttribute("value", variantId);
            productForm.appendChild(idInput);
          }
        } else if (!existingIdInput.value && variantId) {
          // Si existe el input pero no tiene valor, le asignamos el valor de la variante
          existingIdInput.value = variantId;
        }
      }

      // add hidden input to the product-form
      let hidden_input = document.createElement("input");
      hidden_input.setAttribute("type", "hidden");
      hidden_input.setAttribute(
        "name",
        'properties[' + customization_text_input.getAttribute("data-name") + ']'
      );
      hidden_input.setAttribute("value", "");
      hidden_input.setAttribute("id", "customization_text_hidden");
      document.querySelector("form.product-form").appendChild(hidden_input);

      customization_text_input.addEventListener("input", function () {
        this.classList.remove('input-error');

        let value = this.value.toLowerCase();
        const mayusRadio = document.getElementById("initial_mayus");
        if (mayusRadio && mayusRadio.checked && value.length > 0) {
          value = value.charAt(0).toUpperCase() + value.slice(1);
        }

        this.value = value;
        document.getElementById("customization_text_hidden").setAttribute("value", value);

        if (value === '' && customization_text_input.getAttribute('required') !== null) {
          this.classList.add('input-error');
        }
      });

      const radios = document.querySelectorAll('input[name="primera_letra_visible"]');

      if (radios.length > 0) {
        const form = document.querySelector("form.product-form");

        if (form) {
          const hiddenInput = document.createElement("input");
          hiddenInput.type = "hidden";
          hiddenInput.name = 'properties[' + radios[0].getAttribute("data-name") + ']';
          hiddenInput.value = document.querySelector('input[name="primera_letra_visible"]:checked')?.value || '';
          hiddenInput.id = "inicial_hidden";

          form.appendChild(hiddenInput);

          radios.forEach((radio) => {
            radio.addEventListener("change", function () {
              hiddenInput.value = this.value;
              customization_text_input.dispatchEvent(new Event('input'));
            });
          });
        }
      }

      // handle custom text length by numbers
      let letter_selector = document.querySelector('[data-product-variants] .radio__legend__option-name');
      if(null !== letter_selector && letter_selector.textContent === document.getElementById('letter_variant_text_identifier').value) {
        let radio_buttons = letter_selector.parentElement.parentElement.nextElementSibling;
        if(radio_buttons.classList.contains('radio__buttons')) {
          radio_buttons.childNodes.forEach((element) => {
            if(undefined !== element.classList && element.classList.contains('radio__button')) {
              // check already selected variants
              for(let i = 0; i < element.children.length; i++){
                if (element.children[i].tagName === "INPUT" && element.children[i].checked) {
                  customization_text_input.setAttribute('maxlength', element.children[i].value)
                }
              }
              
              element.addEventListener("click", (event) => {
                customization_text_input.value = ""
                document.getElementById('customization_text_hidden').value = ""

                for(let i = 0; i < element.children.length; i++){
                  if (element.children[i].tagName === "INPUT") {
                    customization_text_input.setAttribute('maxlength', element.children[i].value)
                  }
                }
              })
            }
          })
        }
      }
    }
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
